import { render } from "./VideoRowShell.vue?vue&type=template&id=e84f1f4e&scoped=true"
import script from "./VideoRowShell.vue?vue&type=script&lang=js"
export * from "./VideoRowShell.vue?vue&type=script&lang=js"

import "./VideoRowShell.vue?vue&type=style&index=0&id=e84f1f4e&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e84f1f4e"]])

export default __exports__